module.exports = __webpack_public_path__ + "components/MapControl/svg/Agroturystyka.svg?31968da5";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Agroturystyka.svg
// module id = 1960
// module chunks = 0